import { createBrowserRouter } from "react-router-dom";
import appRoutes from "./app.routes.jsx";
import authRoutes from "./auth.routes.jsx";

const router = createBrowserRouter([
      ...authRoutes,
      ...appRoutes,
]);

export default router;